import React, { useState, useEffect } from "react";
import {
    Typography,
    Card,
    CardContent,
    Grid,
    // Button,
    TextField,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Paper
} from "@mui/material";
// import AddIcon from '@mui/icons-material/Add';
import { Search } from "@mui/icons-material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
// import ModalNotificacao from "./ModalNotificacao";
import { Breadcrumbs, Link } from "@mui/material";
import axios from "axios";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import DownloadIcon from '@mui/icons-material/Download';
import CachedIcon from '@mui/icons-material/Cached';
// import ModalAdicionarServico from "./ModalAdicionarServico";
// import ModalEditarServico from "./ModalEditarServico";
// import ModalExcluirServico from "./ModalExcluirServico";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";


const Servicos = () => {
    const { user } = useUser();
    const navigate = useNavigate();

    const [busca, setBusca] = useState("");
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    // const [openModalAdicionarServico, setOpenModalAdicionarServico] = useState(false);
    // const [openModalEditarServico, setOpenModalEditarServico] = useState(false);
    // const [openModalExcluirServico, setOpenModalExcluirServico] = useState(false);
    const [servicos, setServicos] = useState([]);
    const [filteredServicos, setFilteredServicos] = useState([]);
    // const [idServico, setIdServico] = useState(null);

    useEffect(() => {
        // Verifica se o usuário está com servico vencida
        const hasservicosVencidas = user?.servicos?.vencidas?.length > 0;

        if (hasservicosVencidas) {
            setUserActive(false);
        } else {
            setUserActive(true);
        }
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes)
            }
        }

        getNotify();
    }, [])

    useEffect(() => {
        const getServicos = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarServicos`, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });
            console.log(response.data.servicos);
            if (response.data.status === 200) {
                setServicos(response.data.servicos);
                setFilteredServicos(response.data.servicos);
            }
        }

        getServicos();

    }, [])

    const handleSearch = (value) => {
        setBusca(value);
        if (value.trim() === "") {
            // Se a busca estiver vazia, exibe todos os serviços
            setFilteredServicos(servicos);
        } else {
            // Filtra os serviços com base na busca
            const filtered = servicos.filter((servico) =>
                servico.discriminacao.toLowerCase().includes(value.toLowerCase()) || servico.codigo.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredServicos(filtered);
        }
    };


    const formatarData = (data) => {
        return new Intl.DateTimeFormat("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            timeZone: "UTC",
        }).format(new Date(data));
    };

    const cards = [
        {
            title: "Importante",
            description:
                "Esta lista é gerada automaticamente com base no seu cartão CNPJ. Para alterações, entre em contato com nossa equipe de suporte.",
            icon: <InfoOutlinedIcon />,
            bg: "#DFF7EA",
            iconBg: "#00C853",
        },
        // {
        //     title: "Relatórios",
        //     description:
        //         "Você pode exportar esta listagem no menu de Relatórios em formato PDF ou XLSX para apresentações externas.",
        //     icon: <DescriptionOutlinedIcon />,
        //     bg: "#E8F0FE",
        //     iconBg: "#1E88E5",
        // },
        // {
        //     title: "Histórico",
        //     description:
        //         "Última atualização cadastral realizada em: 12/05/2024 às 14:32 por Sistema Central.",
        //     icon: <HistoryOutlinedIcon />,
        //     bg: "#F5F5F5",
        //     iconBg: "#607D8B",
        // },
    ];


    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <div style={{ padding: "30px", background: "#f4f6f8", minHeight: "100vh", marginTop: "64px" }}>
                <div style={{ width: "100%", height: "fit-content", padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                        <div style={{ width: "80%" }}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    underline="hover"
                                    sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                    color="inherit"
                                    onClick={() => navigate("../Dashboard")}
                                >
                                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Dashboard
                                </Link>
                                <Typography
                                    sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                                >
                                    <HourglassBottomIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Serviços
                                </Typography>
                            </Breadcrumbs>
                        </div>
                    </div>
                </div>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Box sx={{ width: { xs: "90%", md: "80%" }, borderRadius: "8px" }}>
                        <Typography
                            variant="h4"
                            sx={{ fontWeight: 700, mb: 3 }}
                        >
                            Serviços
                        </Typography>
                    </Box>
                </Box>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={{ width: window.innerWidth > 768 ? "80%" : "100%", display: "flex", justifyContent: "flex-start", marginBottom: "10px", gap: 10, flexWrap: "wrap" }}>
                        <div style={{ width: window.innerWidth > 768 ? "280px" : "100%", height: "150px", backgroundColor: "#fff", borderRadius: "8px", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2, padding: "20px", borderLeft: "4px solid #2e7d32" }}>
                            <span style={{ display: "flex", flexDirection: "column", gap: 1, fontSize: "12px", fontWeight: 500 }}>
                                SERVIÇOS
                            </span>
                            <span style={{ fontSize: "34px", fontWeight: 700, color: "#2e7d32" }}>
                                {filteredServicos.length} Ativos
                            </span>
                            <span style={{ display: "flex", alignItems: "center", gap: 1, fontSize: "12px", fontWeight: 500 }}>
                                <CalendarMonthIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Último cadastrado: {
                                    filteredServicos.length > 0
                                        ? `${filteredServicos[filteredServicos.length - 1].codigo} - ${filteredServicos[filteredServicos.length - 1].discriminacao?.slice(0, 45) + "..."
                                        }`
                                        : "..."
                                }
                            </span>
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={{ width: window.innerWidth > 768 ? "80%" : "100%", display: "flex", justifyContent: "space-between", gap: 15, flexWrap: "wrap" }}>
                        <div style={{ width: "100%", minWidth: window.innerWidth > 768 ? "280px" : "100%" }}>
                            <TableContainer component={Paper} sx={{ borderRadius: "12px" }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>ID</strong></TableCell>
                                            <TableCell><strong>Código</strong></TableCell>
                                            <TableCell><strong>Discriminação</strong></TableCell>
                                            <TableCell><strong>Status</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredServicos.length > 0 ? (
                                            filteredServicos.map((servico, index) => (
                                                <TableRow key={servico.idServico}>
                                                    <TableCell>{index + 1}</TableCell>
                                                    <TableCell>{servico.codigo}</TableCell>
                                                    <TableCell>{servico.discriminacao}</TableCell>
                                                    <TableCell><span style={{ color: index + 1 === 1 ? "green" : "#9C01B9", backgroundColor: index + 1 === 1 ? "#E6F4EA" : "#F3E6F9", padding: "2px 6px", borderRadius: "4px" }}>{index + 1 === 1 ? "Principal" : "Secundário"}</span></TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={9} align="center">
                                                    Nenhum serviço encontrado.
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
                <Box
                    sx={{
                        maxWidth: window.innerWidth > 768 ? "80%" : "100%",
                        margin: "40px auto 0 auto",
                        display: "flex",
                        gap: 2,
                        flexWrap: "wrap",
                    }}
                >
                    {cards.map((card, index) => (
                        <Card
                            key={index}
                            sx={{
                                flex: 1,
                                minWidth: 260,
                                display: "flex",
                                gap: 2,
                                padding: 2,
                                borderRadius: 3,
                                backgroundColor: card.bg,
                                alignItems: "flex-start",
                            }}
                        >
                            {/* Icon */}
                            <Box
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: 2,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: card.iconBg,
                                    color: "#fff",
                                    flexShrink: 0,
                                }}
                            >
                                {card.icon}
                            </Box>

                            {/* Text */}
                            <Box>
                                <Typography fontWeight={700} fontSize={16}>
                                    {card.title}
                                </Typography>

                                <Typography fontSize={13} color="text.secondary" mt={0.5}>
                                    {card.description}
                                </Typography>
                            </Box>
                        </Card>
                    ))}
                </Box>
            </div>
        </>
    );
};

export default Servicos;
